import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CommandResult } from '@app/_models/command/commandResult';
import { UserType } from '@app/_models/enums/userType';
import { ExternalInstitutionInformationDto } from '@app/_models/ExternalInstitutionInformationDto';
import { RoleDto } from '@app/_models/roleDto';
import { UserAdminDto } from '@app/_models/userAdminDto';
import { UserProfileDto } from '@app/_models/userProfileDto';
import { UserSpecialistQualificationDto } from '@app/_models/userSpecialistQualificationDto';
import { BaseTableDataService } from './baseTableData.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseTableDataService<UserAdminDto, string> {
  constructor() {
    super('user');
  }

  getUserProfile(): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>(this.baseControllerUrl + '/profile');
  }

  GetExternalInstitutionInformation(): Observable<ExternalInstitutionInformationDto> {
    return this.http.get<ExternalInstitutionInformationDto>(this.baseControllerUrl + '/externalInstitutionInformation');
  }
  updateUserProfile(userProfileDto: UserProfileDto): Observable<CommandResult> {
    return this.http.put<CommandResult>(this.baseControllerUrl + '/profile', userProfileDto);
  }

  getRoles(): Observable<RoleDto[]> {
    return this.http.get<RoleDto[]>(this.baseControllerUrl + '/roles');
  }

  /**
   * Returns the user types (user classes) actually present among the users. A `null` entry means some
   * user has no user type assigned. Used to build the user management filter from occurring values only.
   */
  getUsedUserTypes(): Observable<(UserType | null)[]> {
    return this.http.get<(UserType | null)[]>(this.baseControllerUrl + '/usertypes');
  }

  getUserRoles(): Observable<string[]> {
    return this.http.get<string[]>(this.baseControllerUrl + '/userroles');
  }

  getSpecialistQualifications(userId: string): Observable<UserSpecialistQualificationDto[]> {
    return this.http.get<UserSpecialistQualificationDto[]>(
      `${this.baseControllerUrl}/${userId}/specialist-qualifications`,
    );
  }
}
